import { MODULE } from '@gearbelt/global';
import { queryOptions } from '@tanstack/react-query';

import { ApiService } from '@/services/api-v2';

export const pageConfigKeys = {
  all: ['page-config'] as const,
  byHandle: (workspaceId: string | undefined, handle: MODULE) => [...pageConfigKeys.all, workspaceId, handle] as const,
};

export const getWorkspacePageConfigQueryOptions = ({ workspaceId, handle }: { workspaceId: string; handle: MODULE }) => {
  return queryOptions({
    queryKey: pageConfigKeys.byHandle(workspaceId, handle),
    queryFn: async () => {
      return (await (await ApiService.GetWorkspacePageConfigByHandle({ workspaceId, handle })).json()).pageConfig;
    },
  });
};
